import React, { useEffect, useState } from 'react';
import Button from '../../components/button/Button';
import { ConfigModel } from '../../models/ConfigModel';
import { StateModel } from '../../redux/store';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

export interface NavProps {
  config: ConfigModel;
}

const Navbar = (props: NavProps) => {
  const [stylePath, setStylePath] = useState(
    localStorage.getItem('stylePath') ??
      process.env.PUBLIC_URL + '/customStyle.css'
  );
  const [showCoco, setShowCoco] = useState(false);

  const handleButtonClick = (stsh: string) => {
    setStylePath(stsh);
    localStorage.setItem('stylePath', stsh);
  };

  useEffect(() => {
    const head = document.head;
    const link = document.createElement('link');

    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href =
      localStorage.getItem('stylePath') ??
      process.env.PUBLIC_URL + '/customStyle.css';

    head.appendChild(link);

    return () => {
      head.removeChild(link);
    };
  }, [stylePath]);

  useEffect(() => {
    setShowCoco(
      window.location.href.includes('localhost') ||
        window.location.href.includes('192.168.168.237') ||
        //  window.location.href.includes('doldemo.weberdata.de') ||
        window.location.href.includes('192.168.168.18')
    );
  }, []);

  const link =
    props.config.clientKunde?.toUpperCase() == 'BEXITY'
      ? 'https://bexity.com/'
      : props.config.clientKunde?.toUpperCase() == 'MMT'
      ? 'https://www.mm-tl.de/'
      : props.config.clientKunde?.toUpperCase() == 'HAALBOOM'
      ? 'https://www.haalboom.de/'
      : props.config.clientKunde?.toUpperCase() == 'PHL'
      ? 'https://phl-logistik.de/'
      : props.config.clientKunde?.toUpperCase() == 'GERSTLAUER'
      ? 'https://www.gerstlauer.com/'
      : 'https://www.weberdata.de';

  return (
    <nav id='navbar'>
      <a href={link} target='_blank' rel='noreferrer'>
        <img className='logo' src={process.env.PUBLIC_URL + '/wds-logo.png'} />
        <div>
          <small>
            <small>(Version 2025.01.10.1051)</small>
          </small>
        </div>
      </a>
      <div className='icon-wrapper'>
        {props.config.isCustomstylebuttons && (
          <Button
            tooltip={'Bexity-Style'}
            classes={'Bexity'}
            onClickHandler={() => handleButtonClick('customStyle.css')}
          >
            &hearts;
          </Button>
        )}
        {props.config.isCustomstylebuttons && (
          <Button
            tooltip={'MMT-Style'}
            classes={'MMT'}
            onClickHandler={() => handleButtonClick('customStyleMMT.css')}
          >
            &#9827;
          </Button>
        )}
        {props.config.isCustomstylebuttons && (
          <Button
            tooltip={'Eco-Style'}
            classes={'Eco'}
            onClickHandler={() => handleButtonClick('customStyleEco.css')}
          >
            &#9830;
          </Button>
        )}
        {props.config.isCustomstylebuttons && (
          <Button
            tooltip={'PHL-Style'}
            classes={'phl'}
            onClickHandler={() => handleButtonClick('customStylePHL.css')}
          >
            &#9824;
          </Button>
        )}
        {showCoco && (
          <Link to='/admin/coco'>
            <img
              alt='coco'
              src={process.env.PUBLIC_URL + '/coco.jpg'}
              height={'38px'}
            />
          </Link>
        )}
      </div>
    </nav>
  );
};

const mapStateToProps = (state: StateModel) => ({
  config: state.Config,
});
export default connect(mapStateToProps, {})(Navbar);
